import { Box, Button, Container, Grid, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import DataTable from '../Table';
import SearchIcon from '@material-ui/icons/Search';
import Layout from '../Layout';
import { ToastContainer, toast } from 'react-toastify';
import GetAppIcon from '@material-ui/icons/GetApp';
import 'react-toastify/dist/ReactToastify.css';
// import Select from 'react-select';
import { getAssetTransferLogs } from '../../ReduxStore/VendorDataSlice';
import * as XLSX from 'xlsx';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import CustomBreadcrumbs from '../Breadcrumb';
import RefreshIcon from '@material-ui/icons/Refresh';
import { formatDateTime } from '../../helpers/DateConvert';

// const customStyles = {
//     menu: (provided) => ({
//         ...provided,
//         zIndex: 9999,
//     })
// };


const columns = [
    { id: 'Sr.no', label: 'Sr No', minWidth: 80 },
    { id: 'Action', label: 'Action', minWidth: 80 },
    { id: 'old_vendor_no', label: 'Current Vendor Code', minWidth: 150 },
    { id: 'request_ref_no', label: 'Request Ref. No', minWidth: 150 },
    { id: 'old_vendor_name', label: 'Current Vendor Name', minWidth: 150 },
    { id: 'old_vendor_location', label: 'Current Location', minWidth: 150 },
    { id: 'new_vendor_no', label: 'New Vendor Code', minWidth: 150 },
    { id: 'new_vendor_name', label: 'New Vendor Name', minWidth: 150 },
    { id: 'new_vendor_location', label: 'New Location', minWidth: 150 },
    { id: 'raiser_name', label: 'Requestor Name', minWidth: 150 },
    { id: 'raiser_dept', label: 'Requestor Department', minWidth: 180 },
    { id: 'raiser_date', label: 'Transfer Date', minWidth: 150 },
    { id: 'reason', label: 'Reason of Transfer', minWidth: 150 },
    { id: 'NewSupplierAcknowledge', label: 'New Supplier Acknowledge', minWidth: 150 },
    { id: 'status', label: 'Status', minWidth: 80 },
];
const AssetTransferTable = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [assetTransfers, setAssetTransfers] = useState([]);
    const [formData, setFormData] = useState({
        startDate: '',
        endDate: ''
    });

    // const parseDate = (dateStr) => {
    //     // Convert "22-10-2024 12:49 PM" to "2024-10-22T12:49:00"
    //     const [datePart, timePart] = dateStr.split(" ");
    //     const [day, month, year] = datePart.split("-");
    //     const [time, period] = timePart.split(" ");
    //     let [hours, minutes] = time.split(":");

    //     // Adjust hours based on AM/PM
    //     if (period === "PM" && hours !== "12") {
    //         hours = String(parseInt(hours) + 12);
    //     } else if (period === "AM" && hours === "12") {
    //         hours = "00";
    //     }

    //     return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const searchHandler = async () => {
        if (!formData.startDate) {
            toast.warn("Please select the Start Date first!")
            return
        }
        getAssetTransfers(`?from_time=${formatDateTime(formData.startDate)}&to_time=${formatDateTime(formData.endDate)}&sort=true`)
    }

    const resetHandler = async () => {
        setFormData({ startDate: '', endDate: '' });
        await getAssetTransfers(); // Refresh logs without filters
    };

    const getAssetTransfers = async (param) => {
        try {
            // const action = dispatch(getAssetTransferLogs(`?id=0da5fc47361542e2bbaa5cd3feb3f156`));
            const action = dispatch(getAssetTransferLogs(param));
            const res = await action.unwrap();
            if (res.result) {
                const mergedtransfers = res.result
                    .map(transfer => ({
                        ...transfer,
                        raiser_date: convertUTCtoIST(transfer.raiser_date),
                    }))
                setAssetTransfers(mergedtransfers);
            }
        } catch (error) {
            toast.error(error.message || "No Logs Found!");
        }
    }

    const exportToExcel = () => {
        // Create a new worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(assetTransfers);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a buffer and trigger the download
        XLSX.writeFile(workbook, 'Asset_Transfer.xlsx');
    };


    // const statusOptions = [
    //     { value: 'system', label: 'System' },
    //     { value: 'user', label: 'User' }
    // ];

    useEffect(() => {
        const fetchData = async () => {
            await getAssetTransfers();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Transfer Table" />
                </Box>
                <Box mt={4} mb={2}>
                    {/* className='log-row' */}
                    <Grid container spacing={1}>
                        {/* <Grid item xs={12} sm={2}>
                            <Select
                                styles={customStyles}
                                options={statusOptions}
                                placeholder="Select Status"
                                isSearchable
                                isClearable
                                // value={selectedType}
                                menuPlacement="auto"
                            // onChange={setselectedType}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={searchHandler}
                                // endIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
                                endIcon={<SearchIcon />}
                            >
                                Search
                            </Button>

                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="customButton"
                                fullWidth
                                onClick={resetHandler}
                                endIcon={<RefreshIcon />}
                            >
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                {/* <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}
                <div>
                    <Grid container>
                        {/* <Grid item xs={12}>
                            <DataTable data={assetTransfers} columns={columns} pagination={false} />
                        </Grid> */}
                        <Grid item xs={12}>
                            {assetTransfers.length === 0 ? (
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <Box className="no-data-box">
                                        <div className="no-data-text">
                                            No data available for asset transfer.
                                        </div>
                                    </Box>
                                </Box>

                            ) : (
                                <DataTable data={assetTransfers} columns={columns} pagination={false} />
                            )}
                        </Grid>
                    </Grid>
                </div>
                <ToastContainer />
            </Container>
        </Layout>

    )
}

export default AssetTransferTable